import { Button, Box, Grid, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { OrganizationsClient, SubGroupResponseDTO, SubGroupsClient } from '../generated/ApiClient'
import MUIDataTable from "mui-datatables";
import { Link as RouterLink, RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { tableOptions as options } from '../common/Shared'
import { Admin, useIsUserInRoles } from '../hooks/useIsUserInRoles';

interface SubgroupsData {
    name: string;
    externalId: string;
}

export default function Subgroups(props: { organizationId: string }) {
    const [subGroupData, setSubgroupData] = useState<SubgroupsData[]>([]);
    const canEditSubgroups = useIsUserInRoles(Admin)
    const tableOptions = {
        ...options,
        selectableRowsHideCheckboxes: !canEditSubgroups,
        onRowsDelete: ((rowsDeleted: { lookup: any; data: { index: number; dataIndex: number; }[]; }, data: SubgroupsData[]) => {
            const selectedIndexs = rowsDeleted.data.map((row) => row.dataIndex);
            const subgroupIds: string[] = selectedIndexs.map((index) => subGroupData![index].externalId);
            removeSubgroups(subgroupIds);
        })
    }

    const dispatch = useDispatch()
    const removeSubgroups = async (subgroupIds: string[]) => {
        try {
            subgroupIds.map((subgroupId) => removeSubgroup(subgroupId));
            dispatch(snackbar.addMessage({ title: "Success", message: `Subgroups successfully removed`, alertType: 'success' }))
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }
    const removeSubgroup = async (subgroupId: string) => {

        await new SubGroupsClient().delete3(subgroupId);
        setSubgroupData(subGroupData.filter(x => x.externalId != subgroupId))
    }


    const columns = [
        {
            name: "name",
            label: "Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: 'detailsButton',
            label: 'View',
            options: {
                sort: false,
                filter: false,
                customBodyRenderLite: (dataIndex: number) => {
                    const link = `/organizations/${props.organizationId}/subgroups/${subGroupData[dataIndex].externalId}`;
                    return <Button component={RouterLink} variant='contained' size='small' to={link}>View</Button>
                }
            }
        },
    ];

    function toViewData(subgroup: SubGroupResponseDTO) {
        return { name: subgroup.name, externalId: subgroup.externalId }
    }

    useEffect(() => {
        const fetchData = async () => {
            const subGroups = await new OrganizationsClient().getAllSubgroups(props.organizationId);
            setSubgroupData(subGroups.map(toViewData));
        }
        fetchData();
    }, [props.organizationId])

    return (
        <>
            {canEditSubgroups &&
                <Grid container item direction='column' spacing={2} alignItems='flex-end'>
                    <Box my={2}>
                        <Button component={RouterLink} variant='contained' color='primary' size='medium' to={`/organizations/${props.organizationId}/subgroups/create`}>+ Create</Button>
                    </Box>
                </Grid>
            }
            <MUIDataTable
                title={""}
                data={subGroupData}
                columns={columns}
                options={tableOptions}
            />
        </>
    )
}

export function SubgroupsPage(props: RouteComponentProps<{ organizationId: string }>) {

    return (
        <>
            <Typography variant='h4' id="tabelLabel">Subgroups</Typography>
            <Subgroups organizationId={props.match.params.organizationId} />
        </>
    )
}

